import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import React, { ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, subtitle, action }) => (
  <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
    <SpaceBetween size="m">
      <Box variant="strong" textAlign="center" color="inherit">
        {title}
      </Box>
      {subtitle && (
        <Box variant="p" padding={{ bottom: "s" }} color="inherit">
          {subtitle}
        </Box>
      )}
      {action}
    </SpaceBetween>
  </Box>
);

export default EmptyState;
